// extracted by mini-css-extract-plugin
module.exports = {"ThreadTitle":"_2KSG-ct2","ThreadTitleSubject":"_2d4PaOHz","ThreadInfo":"_3TMOnGvV","backButton":"_3btljHZ1","copyButton":"mXBfrmhs","tooltip_content":"_3SqQipCX"};